<template>
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 40 40"
        fill="#9A247B"
      >
        <path
          d="M18.7499 4.57564C18.7499 4.38132 18.5834 4.22795 18.3901 4.24747C10.4017 5.05413 4.1666 11.7989 4.1666 20C4.1666 28.7445 11.2554 35.8333 19.9999 35.8333C24.3945 35.8333 28.3711 34.0422 31.2389 31.1525C31.3759 31.0144 31.3608 30.7889 31.2095 30.6667L19.2142 20.9722C18.9206 20.7349 18.7499 20.3775 18.7499 20V4.57564Z"
          fill="currentColor"
        />
        <path
          d="M32.7823 28.7234C32.9335 28.8456 33.157 28.8132 33.2633 28.6505C34.6117 26.587 35.4919 24.1891 35.7525 21.609C35.772 21.4157 35.6185 21.25 35.4242 21.25H24.478C24.1637 21.25 24.024 21.645 24.2685 21.8426L32.7823 28.7234Z"
          fill="currentColor"
        />
        <path
          d="M35.4243 18.75C35.6186 18.75 35.772 18.5836 35.7524 18.3902C34.9993 10.9311 29.0688 5.00063 21.6097 4.24747C21.4163 4.22794 21.2499 4.38132 21.2499 4.57564V18.25C21.2499 18.5261 21.4738 18.75 21.7499 18.75H35.4243Z"
          fill="currentColor"
        />
      </svg>
    </div>
  </template>
  